import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  height: 21px;
  width: 21px;
`
export const QrCodeIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg className={className} width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.833 17.5v-1.667H12.5V17.5h-1.667Zm-1.666-1.667v-4.166h1.666v4.166H9.167Zm6.666-2.5V10H17.5v3.333h-1.667ZM14.167 10V8.333h1.666V10h-1.666Zm-10 1.667V10h1.666v1.667H4.167ZM2.5 10V8.333h1.667V10H2.5ZM10 4.167V2.5h1.667v1.667H10ZM3.542 6.458h2.916V3.542H3.542v2.916ZM2.5 7.5v-5h5v5h-5Zm1.042 8.958h2.916v-2.916H3.542v2.916ZM2.5 17.5v-5h5v5h-5ZM13.542 6.458h2.916V3.542h-2.916v2.916ZM12.5 7.5v-5h5v5h-5Zm1.667 10V15H12.5v-1.667h3.333v2.5H17.5V17.5h-3.333Zm-3.334-5.833V10h3.334v1.667h-3.334Zm-3.333 0V10H5.833V8.333h5V10H9.167v1.667H7.5ZM8.333 7.5V4.167H10v1.666h1.667V7.5H8.333ZM4.375 5.625v-1.25h1.25v1.25h-1.25Zm0 10v-1.25h1.25v1.25h-1.25Zm10-10v-1.25h1.25v1.25h-1.25Z"
        fill="#916EE8"
      />
    </Svg>
  )
}
